enum NumberFormatDescription {
	Undefined = 0,
	Integer = 1,
	Decimal = 2,
	Percent = 3,
	Currency = 4
}

export default NumberFormatDescription;
